import { Injectable } from '@angular/core';

export interface PagePopulationInformation {
  contactInfo: string;
  method: 'otp' | 'sms';
  bearer: string;
}

@Injectable({
  providedIn: 'root',
})
export class PagePopulationService {
  public populationInformation: PagePopulationInformation | null = null;
}
